<template>
    <MainContainer>
        <div class="fibu-op-buchung">
            <h2>
                <template>
                    Offenen Posten ID {{ id }} verbuchen
                </template>
            </h2>
            <div class="fibu-op-buchung-fields">
                <FormGroupBuilder
                    :fields="ioFields"
                    :data="data"
                    :refresh="validationRefresh"
                />
                <template v-if="diff > 0">
                        <b-button
                            type="submit"
                            class="total-btn mr-1"
                            variant="primary"
                            :disabled="busy"
                            @click="dataProvideWithGuthaben"
                        >
                            <template v-if="!busy">Buchen (Überzahlung als Guthaben)</template>
                            <template v-else>
                                <Spinner small variant="light" />
                            </template>
                        </b-button>

                        <b-button
                            type="submit"
                            class="total-btn mr-1"
                            variant="primary"
                            :disabled="busy"
                            @click="dataProvideWithSpendeForSingpause"
                        >
                            <template v-if="!busy">Buchen (Überzahlung auf Singpause)</template>
                            <template v-else>
                                <Spinner small variant="light" />
                            </template>
                        </b-button>

                        <b-button
                            type="submit"
                            class="total-btn mr-1"
                            variant="primary"
                            :disabled="busy"
                            @click="dataProvideWithSpende"
                        >
                            <template v-if="!busy">Buchen (Überzahlung auf Spende)</template>
                            <template v-else>
                                <Spinner small variant="light" />
                            </template>
                        </b-button>
                </template>

                <template v-else>
                    <b-button
                        type="submit"
                        class="total-btn mr-1"
                        variant="primary"
                        :disabled="busy"
                        @click="dataProvide"
                    >
                        <template v-if="!busy">Buchen</template>
                        <template v-else>
                            <Spinner small variant="light" />
                        </template>
                    </b-button>
                </template>
                <b-button
                    type="cancel"
                    @click="pushToRoute"
                    class="total-btn"
                    variant="outline-secondary"
                >
                    <template v-if="checkRight('write')">Abbrechen</template>
                    <template v-else>Zurück</template>
                </b-button>
            </div>
            <div class="fibu-op-buchung-redirect">
                <b-button
                  type="submit"
                  class="total-btn mt-2"
                  variant="outline-primary"
                  :disabled="busy"
                  @click="executeAndRedirect"
                >
                  <template v-if="!busy">Buchen und zu all. Buchung wechseln</template>
                  <template v-else>
                    <Spinner small variant="light" />
                  </template>
                </b-button>
            </div>
        </div>
    </MainContainer>
</template>

<script>
import Toaster from "@/mixins/Toaster/Toaster";
import Rights from "@/mixins/Rights/Rights";
import Validation from "@/mixins/Validation/Validation";

import { ApiFactory } from "@/api/ApiFactory.js";

import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import Spinner from "@/components/Spinner/Spinner";
import MainContainer from "../../components/MainContainer/MainContainer";

const FiBuOffenePostenApi = ApiFactory.get("fibuOffenePosten");
const FiBuVerwendungszweckApi = ApiFactory.get("fibuVerwendungszweck");
const FiBuFinanzkontoApi = ApiFactory.get("fibuFinanzkonto");
const FiBuBuchungskontoApi = ApiFactory.get("fibuBuchungskonto");

export default {
    name: "OffenePostenBuchung",
    mixins: [Toaster, Rights, Validation],
    components: {
        MainContainer,
        FormGroupBuilder,
        Spinner
    },
    data() {
        return {
            ioFields: {
                datum: {
                    key: "datum",
                    label: "Zeitpunkt der Buchung",
                    type: "date"
                },
                mitglied: {
                    key: "mitglied",
                    label: "Mitglied",
                    type: "mitgliederinput",
                    disabled: true
                },
                finanzkonto_id: {
                    key: "finanzkonto_id",
                    label: "Finanzkonto",
                    type: "filteredselect",
                    disabled: false,
                    options: []
                },
                buchungskonto_id: {
                    key: "buchungskonto_id",
                    label: "Buchungskonto",
                    type: "filteredselect",
                    disabled: false,
                    options: []
                },
                verwendungszweck_text: {
                    key: "verwendungszweck_text",
                    label: "Verwendungszweck",
                    disabled: true
                },
                betrag: {
                    key: "betrag",
                    label: "Betrag",
                    type: "fibuamountinput",
                    min: 0
                },
            },
            data: {},
            isOverpaid: false,
            busy: false,
            id: this.$route.params.id,
            verwendungszweck: {
                busy: false,
                items: [],
                options: []
            },
            finanzkonto: {
                busy: false,
                items: [],
                options: [],
            },
            buchungskonto: {
                busy: false,
                items: [],
                options: []
            },
            hash: this.$route.hash,
            redirect: false
        }
    },
    created() {
        this.fetchFinanzkonto();
        this.fetchBuchungskonto();
        this.fetchVerwendungszweck();
        this.fetch();
    },
    computed: {
        diff() {
            return Number(this.data.balance) + Number(this.data.betrag);
        },
        noBuchungsKonto() {
            return this.data.buchungskonto_id;
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await FiBuOffenePostenApi.getSingleForBuchung(this.id);
            if (response.ok) {
                this.registerRights(response);
                this.cleanPayload(response.json);
                const data = response.json;
                this.data = Object.assign(data);

                const pages = this.$store.getters.getPages;

                if(pages.fibu_offene_posten.datum) {
                  this.data.datum = pages.fibu_offene_posten.datum;
                }
            }
            this.noBuchungsKonto ? this.ioFields.buchungskonto_id.disabled = true : '';

            this.busy = false;
        },
        async fetchVerwendungszweck() {
            this.verwendungszweck.busy = true;
            const response = await FiBuVerwendungszweckApi.get();
            if (response.ok) {
                this.verwendungszweck.items = response.json.collection;
            }
            this.verwendungszweck.busy = false;
        },
        async fetchFinanzkonto() {
            this.finanzkonto.busy = true;
            const response = await FiBuFinanzkontoApi.get();
            if (response.ok) {
                this.finanzkonto.items = response.json.collection;
                const options = response.json.collection.map(item => {
                    return {
                        text: `${item.kontonr} - ${item.text}`,
                        value: item.id
                    };
                });
                this.finanzkonto.options = options;
                this.ioFields.finanzkonto_id.options = options;
            }
            this.finanzkonto.busy = false;
        },
        async fetchBuchungskonto() {
            this.buchungskonto.busy = true;
            const response = await FiBuBuchungskontoApi.get();
            if (response.ok) {
                this.buchungskonto.items = response.json.collection;
                const options = response.json.collection.map(item => {
                    return {
                        text: `${item.kontonr} - ${item.text}`,
                        value: item.id
                    };
                });
                this.buchungskonto.options = options;
                this.ioFields.buchungskonto_id.options = options;
            }
            this.buchungskonto.busy = false;
        },
        dataProvideWithGuthaben() {
            if(this.diff > 0) {
                this.data.guthaben = this.diff;
            }
            this.dataProvide();
        },
        dataProvideWithSpende() {
            if(this.diff > 0) {
                this.data.spende = this.diff;
            }
            this.dataProvide();
        },
        dataProvideWithSpendeForSingpause() {
            if(this.diff) {
                this.data.singpause = this.diff;
            }
            this.dataProvide();
        },
        async dataProvide() {
            this.busy = true;

            this.$store.dispatch('pages', {
              fibu_offene_posten: {
                datum: this.data.datum
              }
            })

            var response = await FiBuOffenePostenApi.postBuchungForOP(this.id, this.data);

            if (response.ok) {
                this.cleanValidationData(this.ioFields);
                this.makeToast(
                    "Erfolgreich gespeichert",
                    "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                );

                if(this.redirect) {
                    this.redirect = false;
                    window.location.href = '/fibu/buchung/new';
                } else {
                    if(this.hash !== '') {
                      this.$router.push({
                        path: `/fibu/offene_posten`,
                        hash: `${this.hash}`
                      });
                    } else {
                      this.$router.push({
                        path: `/fibu/offene_posten`,
                        hash: `#${this.id}`
                      });
                    }
                }

            } else {
                this.handleValidationData(response, this.ioFields);
            }
            this.busy = false;
        },
        cleanPayload(json) {
            Object.keys(json).forEach(key => {
                if (key.startsWith("_")) {
                    delete json[key];
                }
            });
        },
        removeMitgliedRel() {
            this.data.mitglied_id = null;
        },
        pushToRoute() {
            this.$router.push({
                path: `/fibu/offene_posten`,
                hash: `${this.id}`
            });
        },
        executeAndRedirect() {
          this.redirect = true;
          this.dataProvide();
        }
    },
    watch: {
        data: {
            handler(val) {
                val.mitgliedsbeitrag ? this.ioFields.finanzkonto_id.disabled = true : '';
                val.ueberzahlung_buchungskonto_id_MV ? '' : this.data.ueberzahlung_buchungskonto_id_MV = 18;
                val.ueberzahlung_buchungskonto_id_SP ? '' : this.data.ueberzahlung_buchungskonto_id_SP = 26;
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>